import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * Сервис для получения коллекций элементов, используемых в селектах.
 * Элементы вида {id: number, title: string}
 */
@Injectable()
export class SelectValuesApiService extends ApiService {
    baseUrl = '';

    /**
     * Получение данных для формирования селектора методов для списка заключений.
     */
    public methodsForConclusionList = 'select/method/conclusion-list';

    /**
     * Получение данных для формирования селектора методов для журнала заключений.
     */
    public methodsForConclusionJournal = 'select/method/conclusion-journal';

    /**
     * Получение данных для формирования селектора объектов работ для списка заключений.
     */
    public workingObjectsForConclusionList = 'select/working-object/conclusion-list';

    /**
     * Получение данных для формирования селектора объектов работ для журнала заключений.
     */
    public workingObjectForConclusionJournal = 'select/working-object/conclusion-journal';

    /**
     * Получение данных для формирования селектора технических устройств для списка заключений.
     */
    public technicalDeviceForConclusionList = 'select/technical-device/conclusion-list';

    /**
     * Получение данных для формирования селектора типов статусов заключений для списка заключений.
     */
    public conclusionStatusForConclusionList = 'select/conclusion-status/conclusion-list';
}
